import React from 'react'
import { observer, useLocalStore } from 'mobx-react-lite'
import { EmployeeCtx, employeeStore } from './EmployeeStore'
import { appStore } from '../common/AppStore'
import { SCOPES } from '../config/constants'
import { storeMergedProducts } from '../common/StoreProducts'
import { useDidMount } from '../common/utils/hooks/useDidMount'
import { Bar, BarItem } from '../common/ui-kit/bar'
import { Loader } from '../common/ui-kit/loader'

/**
 * Fetch employee based on current user for scope `Holder` and sets it's value on context `EmployeeCtx`
 */
export const FetchEmployee = observer((props: { children: JSX.Element }) => {
  const state = useLocalStore(() => ({
    state: 'initial' as 'initial' | 'loaded' | 'error',
    async fetchProducts() {
      try {
        await storeMergedProducts.fetch(SCOPES.Holder)
        this.state = 'loaded'
      } catch (err) {
        this.state = 'error'
      }
    },
  }))

  useDidMount(() => {
    const employeeIdFromLocalStorage = employeeStore.getEmployeeIdFromLocalStorage()

    if (employeeIdFromLocalStorage && appStore.hasIdInAccesses(employeeIdFromLocalStorage)) {
      appStore.checkMigrationForEntity(employeeIdFromLocalStorage, SCOPES.Holder)
      employeeStore.fetchEmployee(employeeIdFromLocalStorage).then(state.fetchProducts)
    } else {
      const employeeId = appStore.getIdInScope(SCOPES.Holder)

      if (employeeId) {
        employeeStore.saveEmployeeIdToLocalStorage(employeeId)
        appStore.checkMigrationForEntity(employeeId, SCOPES.Holder)
        employeeStore.fetchEmployee(employeeId).then(state.fetchProducts)
      }
    }
  })

  if (!employeeStore.employee || state.state !== 'loaded')
    return (
      <Bar align="middle">
        <BarItem
          isFilling
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '110px',
            paddingBottom: '110px',
          }}>
          <Loader size="large" />
        </BarItem>
      </Bar>
    )

  appStore.saveLastEntityIdToLocalStorage(employeeStore.employee.id)
  appStore.currentRole = SCOPES.Holder

  return (
    <EmployeeCtx.Provider value={employeeStore.employee}>{props.children}</EmployeeCtx.Provider>
  )
})
